export default __webpack_public_path__ + "static/media/captain.6aa4f567.jp2";